import { AxiosResponse } from 'axios'
import { inject, InjectionKey, ref } from 'vue'
import { User } from '../../../libs/models'
import { useApi } from './api'
import { l } from './localization'

export interface FollowsStore {
  readonly value: User[] | null
  fetch: () => Promise<User[]>
  follow: (userId: number) => void
  unfollow: (userId: number) => void
  getIsFollowed: (userId: number) => boolean
}
export const generateFollowersStore = (): FollowsStore => {
  const follows = ref<User[] | null>(null)
  const api = useApi()
  const fetch = (): Promise<User[]> => {
    return api.get('/users/follows').then(({ data }: AxiosResponse<User[]>) => {
      follows.value = data
      return data
    })
  }
  const follow = (userId: number) => {
    if (follows.value && follows.value?.length >= 50) return alert(l('これ以上ブックマークできません'))
    api.post(`/users/${userId}/follow`).then(({ data }: AxiosResponse<User>) => {
      follows.value?.push(data)
    })
  }
  const unfollow = (userId: number) => {
    api.post(`/users/${userId}/unfollow`).then(() => {
      follows.value = follows.value?.filter(v => v.id !== userId) || null
    })
  }
  const getIsFollowed = (userId: number) => {
    return follows.value?.some(v => v.id === userId) || false
  }
  return {
    get value () {
      return follows.value
    },
    fetch,
    follow,
    unfollow,
    getIsFollowed
  }
}
export const followsStoreKey: InjectionKey<FollowsStore> = Symbol()
export const useFollowsStore = (): FollowsStore => {
  const followsStore = inject(followsStoreKey)
  if (!followsStore) throw Error('Could not inject followsStore')
  return followsStore
}
